import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Route, Switch, } from 'react-router-dom';
import { withRouter } from "react-router";
import "../index.css";

// Lazy-loaded pages
import Home from "../pages/Home/Home";
// const Home = lazy(() => import("./pages/Home/Home"));
import Award26 from "../pages/Award26/Award26";
import Award25 from "../pages/Award25/Award25";
import Award24 from "../pages/Award24/Award24";
import Award23 from "../pages/Award23/Award23";
import Award22 from "../pages/Award22/Award22";
import Aboutus from "../pages/Aboutus/Aboutus";
import ContactUs from "../pages/ContactUs/ContactUs";
import Privacy from "../pages/PrivacyandPolicy/Privacy";
import Faq from "../pages/Faq/Faq";
import Blog from "../pages/Blog/Blog";
import BlogDetails from "../pages/Blog/BlogDetails";
import News from "../pages/News/News";
import NewsDetails from "../pages/News/NewsDetails";
import NotFoundPage from "../pages/NotFoundPage";
import SchemaMarkup from "../SchemaMarkup";

export default function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute exact path="/" component={withRouter(Home)} />
        <PublicRoute exact path="/home" component={withRouter(Home)} />
        <PublicRoute exact path="/happiest-workplaces-conclave-2027" component={withRouter(Award26)} />
        <PublicRoute exact path="/happiest-workplaces-conclave-2026" component={withRouter(Award25)} />
        {/* <PublicRoute exact path="/happiest-workplaces-annual-conclave-2025" component={withRouter(Award25)} /> */}
        <PublicRoute exact path="/happiness-and-wellbeing-conclave-2025" component={withRouter(Award24)} />
        <PublicRoute exact path="/happiness-and-wellbeing-conclave-2023" component={withRouter(Award23)} />
        <PublicRoute exact path="/happiness-and-wellbeing-conclave-2022" component={withRouter(Award22)} />
        <PublicRoute exact path="/about-us" component={withRouter(Aboutus)} />
        <PublicRoute exact path="/contact-us" component={withRouter(ContactUs)} />
        <PublicRoute exact path="/privacy-policy" component={withRouter(Privacy)} />
        <PublicRoute exact path="/faq" component={withRouter(Faq)} />
        <PublicRoute exact path="/blog" component={withRouter(Blog)} />
        <PublicRoute exact path="/blogdetails/:id" component={withRouter(BlogDetails)} />
        <PublicRoute exact path="/news" component={withRouter(News)} />
        <PublicRoute exact path="/newsdetails/:id" component={withRouter(NewsDetails)} />
        <PublicRoute exact path="/notfound" component={withRouter(NotFoundPage)} />
        <PublicRoute exact path="*" component={withRouter(NotFoundPage)} />
      </Switch>
    </BrowserRouter>
  );

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
        (
          React.createElement(component, props)
        )
        }
      />
    );
  }
}